import styled from 'styled-components';
import {
  Button as ButtonLayoutComponent, Header as HeaderLayoutComponent, Text as TextLayoutComponent, Segment as SegmentLayoutComponent,
} from '@playbookux/playbook-web-core';

export const Container = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding-top: 100px;
`;

export const Segment = styled(SegmentLayoutComponent)`
  &.ui.segment {
    margin-left: auto;
    margin-right: auto;
    padding: 30px;
    width: 750px;
  }
`;

export const Button = styled(ButtonLayoutComponent)`
  &.ui.button {
    margin: 40px auto;
    display: block;
  }
`;

export const Header = styled(HeaderLayoutComponent)``;

export const Text = styled(TextLayoutComponent)``;

export const Bold = styled.strong`
  font-weight: 500;
`;

export const Description = styled.div`
  display: flex;
  margin-top: 20px;
`;
